import { UnionKeyToValue } from "types/typeUtils"

export type TRUTHY_BOOLEAN = 'YES' | 'NONE'

export type BOOLEAN = 'YES' | 'NO' | 'NONE'
export const BOOLEAN_OPTIONS = ["YES", "NO", "NONE"]

export type MEASUREMENT_TYPE = 'ELECTRIC' | 'GAS' | 'WATER'
export const MEASUREMENT_TYPE : UnionKeyToValue<MEASUREMENT_TYPE> = {
  ELECTRIC  : 'ELECTRIC',
  GAS       : 'GAS',
  WATER     : 'WATER'
}

export type ACCOUNT_TYPE = 'RESIDENTIAL' | 'SMB'
export const ACCOUNT_TYPE : UnionKeyToValue<ACCOUNT_TYPE> = {
  RESIDENTIAL : 'RESIDENTIAL',
  SMB         : 'SMB'
}

export type FREQUENCY = 'repeat' | 'one_time'
export const FREQUENCY : UnionKeyToValue<FREQUENCY> = {
  repeat : 'repeat',
  one_time : 'one_time'
}

export type RECO_MODEL_USER_TYPE = 'SOLAR' | 'TOU' | 'EV' | 'BB'
export const RECO_MODEL_USER_TYPE : UnionKeyToValue<RECO_MODEL_USER_TYPE> = {
  SOLAR : 'SOLAR',
  TOU   : 'TOU',
  EV    : 'EV',
  BB    : 'BB'
}

export type RECO_MODEL_ACTION_TYPE = 'ACTIONABLE_TIP' | 'PROGRAM' | 'LMI_PROGRAM' 
  | 'DER_PROGRAM' | 'REBATE' | 'PRODUCT' | 'CX' | 'WEATHER_EVENT' | 'SOCIAL_IMPACT' 
  | 'RATE_PLAN' | 'APPOINTMENT' | 'OUTAGE' | 'DATA_CONSENT'
export const RECO_MODEL_ACTION_TYPE : UnionKeyToValue<RECO_MODEL_ACTION_TYPE> = {
  ACTIONABLE_TIP : 'ACTIONABLE_TIP',
  PROGRAM : 'PROGRAM',
  LMI_PROGRAM : 'LMI_PROGRAM',
  DER_PROGRAM : 'DER_PROGRAM',
  REBATE : 'REBATE',
  PRODUCT : 'PRODUCT',
  CX : 'CX',
  WEATHER_EVENT : 'WEATHER_EVENT',
  SOCIAL_IMPACT : 'SOCIAL_IMPACT',
  RATE_PLAN : 'RATE_PLAN',
  APPOINTMENT : 'APPOINTMENT',
  OUTAGE : 'OUTAGE',
  DATA_CONSENT : 'DATA_CONSENT'
}

export type RECO_MODEL_OBJECTIVE = 'EE' | 'GRID' | 'LMI' | 'ELEC_DER' | 'CX' | 'MREV' | 'COMPL'
export const RECO_MODEL_OBJECTIVE : UnionKeyToValue<RECO_MODEL_OBJECTIVE> = {
  EE : 'EE',
  GRID : 'GRID',
  LMI : 'LMI',
  ELEC_DER : 'ELEC_DER',
  CX : 'CX',
  MREV : 'MREV',
  COMPL : 'COMPL'
}

// API Timeout Configuration
export const API_TIMEOUT = {
  DEFAULT: 30000,        // 30 seconds - default timeout for most API calls
  UPLOAD: 120000,        // 2 minutes - longer timeout for file uploads
  LOGIN: 15000,          // 15 seconds - shorter timeout for login requests
  LONG_OPERATION: 300000 // 5 minutes - for operations that might take longer
} as const

export const RATE_PLAN_DROPDOWN_OPTIONS = [
  {
    group: 'tier',
    label: 'Tiered',
    children: [
      { value: 'NONE', label: 'None' },
      { value: 'YES', label: 'Yes' },
      { value: 'NO', label: 'No' },
    ],
  },
  {
    group: 'tou',
    label: 'TOU',
    children: [
      { value: 'NONE', label: 'None' },
      { value: 'YES', label: 'Yes' },
      { value: 'NO', label: 'No' },
    ],
  },
  {
    group: 'flat',
    label: 'Flat rate',
    children: [
      { value: 'NONE', label: 'None' },
      { value: 'YES', label: 'Yes' },
    ],
  }
];

export const PROGRAM_PARTICIPATION_EXCLUSION_LABEL = {
  "ELIGIBLE_NOT_ENROLLED" : "Eligible, not enrolled",
  "ENROLLED" : "Enrolled",
  "INELIGIBLE" : "Ineligible",
  "NOT_ENROLLED" : "Not enrolled"
}

export const INSIGHT_ASSOCIATION_LABEL = {
  "NC" : "NC",
  "SC" : "SC",
  "CC" : "CC"
}